import { render } from "./SidenavCollapse.vue?vue&type=template&id=7b2426d4&scoped=true"
import script from "./SidenavCollapse.vue?vue&type=script&lang=js"
export * from "./SidenavCollapse.vue?vue&type=script&lang=js"

import "./SidenavCollapse.vue?vue&type=style&index=0&id=7b2426d4&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\New folder\\New folder\\Olt Care\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b2426d4"]])

export default __exports__